/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Booking_Status_PendingInputs */

const en_rental_booking_status_pending = /** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const es_rental_booking_status_pending = /** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const fr_rental_booking_status_pending = /** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

const de_rental_booking_status_pending = /** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

const id_rental_booking_status_pending = /** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tertunda`)
};

/** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */
const ja_rental_booking_status_pending = en_rental_booking_status_pending;

/** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */
const zh_rental_booking_status_pending = en_rental_booking_status_pending;

/** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */
const ar_rental_booking_status_pending = en_rental_booking_status_pending;

/** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */
const it_rental_booking_status_pending = en_rental_booking_status_pending;

/** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */
const ru_rental_booking_status_pending = en_rental_booking_status_pending;

/** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */
const pt_rental_booking_status_pending = en_rental_booking_status_pending;

/** @type {(inputs: Rental_Booking_Status_PendingInputs) => LocalizedString} */
const ko_rental_booking_status_pending = en_rental_booking_status_pending;

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Rental_Booking_Status_PendingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_booking_status_pending = /** @type {((inputs?: Rental_Booking_Status_PendingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Booking_Status_PendingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_booking_status_pending(inputs)
	if (locale === "es") return es_rental_booking_status_pending(inputs)
	if (locale === "fr") return fr_rental_booking_status_pending(inputs)
	if (locale === "de") return de_rental_booking_status_pending(inputs)
	if (locale === "ja") return ja_rental_booking_status_pending(inputs)
	if (locale === "zh") return zh_rental_booking_status_pending(inputs)
	if (locale === "ar") return ar_rental_booking_status_pending(inputs)
	if (locale === "id") return id_rental_booking_status_pending(inputs)
	if (locale === "it") return it_rental_booking_status_pending(inputs)
	if (locale === "ru") return ru_rental_booking_status_pending(inputs)
	if (locale === "pt") return pt_rental_booking_status_pending(inputs)
	return ko_rental_booking_status_pending(inputs)
});